// MonCompte.js
import React, { useState } from 'react';
import MenuClient from '../Components/menuclient';

const MonCompte = () => {
  const [compte] = useState({
    nom: 'LEBEL ELOGE',
    email: 'eloge.lebel@email.com',
    telephone: '+33 6 12 34 56 78',
    iban: 'FR76 3000 6000 0112 3456 7890 189',
    bic: 'AGRIFRPP',
    numeroClient: 'CLT87654321',
  });

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Mon compte</h2>

      <div style={styles.infoBox}>
        <p><strong>Nom :</strong> {compte.nom}</p>
        <p><strong>Email :</strong> {compte.email}</p>
        <p><strong>Téléphone :</strong> {compte.telephone}</p>
        <p><strong>Numéro de compte :</strong> {compte.numeroClient}</p>
        <p><strong>IBAN :</strong> {compte.iban}</p>
        <p><strong>BIC / SWIFT :</strong> {compte.bic}</p>
      </div>

      <button style={styles.button}>Modifier mes informations</button>

      <MenuClient />
    </div>
  );
};

const styles = {
  page: {
    padding: '20px',
    paddingBottom: '80px',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    fontSize: '20px',
    marginBottom: '20px',
  },
  infoBox: {
    backgroundColor: '#f5f5f5',
    padding: '20px',
    borderRadius: '10px',
    fontSize: '15px',
    lineHeight: '1.7',
    marginBottom: '20px',
  },
  button: {
    backgroundColor: '#0061A6',
    color: 'white',
    padding: '12px',
    fontSize: '15px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
  },
};

export default MonCompte;
